module.exports = __webpack_public_path__ + "static/media/tyre-yellow-three3.96376a3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-three3.png
// module id = 356
// module chunks = 0